<template>
  <span v-if="pageIsView || isWorkflowBuilder">
    {{ model.points }}
  </span>
  <lf-content-loader v-else :is-loading="runScorecardIds.includes(model.id)">
    <div class="whitespace-nowrap">
      <div
        v-if="
          modelIsScorecardGroup(model)
            ? isGroupKnockoutTriggered(model)
            : isKnockoutTriggered(model)
        "
        data-cy="knockout-triggered-points"
      >
        <icon-base :icon="IconKnockout" :color="UTIL_COLORS.WARNING" />
        ⁄
        {{ model.points || 0 }}
      </div>
      <template v-else>{{ getPoints(model) }}</template>
    </div>
  </lf-content-loader>
</template>

<script setup lang="ts">
import { UTIL_COLORS } from "@/helpers/constants";
import {
  getPoints,
  isGroupKnockoutTriggered,
  isKnockoutTriggered,
  modelIsScorecardGroup,
} from "@/helpers/scorecards";
import { useScorecardsBase } from "@/hooks/scorecards";

import IconKnockout from "@/components/icons/IconKnockout.vue";
import LfContentLoader from "@/components/ui/LfContentLoader.vue";

import type { IScorecard, IScorecardGroup } from "@/models/scorecards";

const { runScorecardIds } = useScorecardsBase();

defineProps<{
  model: IScorecard | IScorecardGroup;
  pageIsView?: boolean;
  isWorkflowBuilder?: boolean;
}>();
</script>
